/*
  Hides the native Shopify chat launcher (and any other widget exposing a
  `part="activator"` element inside an open shadow root) while the cart
  drawer is open, and restores it on close. CSS alone can't reliably target
  it -- the shadow host's own tag name has changed twice already between
  real devtools inspections (#shopify-chat id, <shopify-chat> tag,
  <shopify-agent-runtime view="chat">) -- so this searches every open
  shadow root recorded by the early-loaded attachShadow patch in
  layout/theme.liquid instead of guessing a selector chain.
*/
(function () {
  function findActivators() {
    var roots = window.__pbShadowRoots || [];
    var found = [];
    for (var i = 0; i < roots.length; i++) {
      var match = roots[i].querySelector('[part="activator"]');
      if (match) found.push(match);
    }
    return found;
  }

  function apply() {
    var hide = document.body.classList.contains('open-cart');
    findActivators().forEach(function (el) {
      el.style.visibility = hide ? 'hidden' : '';
      el.style.pointerEvents = hide ? 'none' : '';
    });
  }

  if (!window.__pbShadowRoots) return; // patch didn't load for some reason -- fail quiet, not broken

  new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // The chat widget's custom elements upgrade asynchronously after this
  // script runs, so the shadow roots it creates may not exist yet on the
  // very first pass -- recheck for a short window after load to catch a
  // late mount, then stop (the MutationObserver above keeps handling open/
  // close after that).
  apply();
  var attempts = 0;
  var interval = setInterval(function () {
    apply();
    attempts += 1;
    if (attempts >= 20) clearInterval(interval); // ~10s at 500ms
  }, 500);
})();
